<template>
  <el-dialog
    title="Zone Bulk Import"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="importForm"
      v-loading="isSaving"
      :model="job"
      size="small"
    >
      <el-row>
        <el-form-item
          label="Attachment"
        >
          <el-select
            v-model="job.attachment"
            placeholder="Please select an attachement"
            :loading="isLoadingAttachments"
            class="w-100"
          >
            <el-option
              v-for="item in attachments"
              :key="item.file.id"
              :label="item.file.name"
              :value="item.file.id"
            />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="Import Type">
          <el-radio
            v-model="job.type"
            label="overwrite"
          >
            Delete all existing and import
          </el-radio>
          <el-radio
            v-model="job.type"
            label="append"
          >
            Add to existing zone list
          </el-radio>
        </el-form-item>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="createImport()"
      >
        Start Import
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    carrierId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      job: {},
      isSaving: false,
      isLoadingAttachments: false,
      isFullscreen: false,
      attachments: []
    }
  },
  created () {
    this.loadAttachments()
  },
  methods: {
    loadAttachments () {
      this.isLoadingAttachments = true
      this.$sdk.attachment.list(builder => {
        builder.context = { resource: 'carrier', id: this.carrierId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:desc'
      })
        .then(res => {
          this.attachments = res
        })
        .finally(() => { this.isLoadingAttachments = false })
    },
    createImport () {
      const job = new this.$sdk.job()
      job.name = 'import.csv.zone'
      job.parameters = {
        attachment: this.job.attachment,
        carrier: this.carrierId,
        type: this.job.type
      }
      job.create()
        .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>

<style>

</style>
